import { TenantEntity } from '@/class/model/TenantEntity'
import { multiLegVoyageManagementUrlFunc } from '@/api/seaExport/multiLegVoyageManagement'

export class MultiLegVoyageManagement extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'MultiLegVoyageManagement'
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }

  get leg() {
    return this._data.leg
  }
  set leg(leg) {
    this._data.leg = leg
  }

  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }

  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }

  get vessel() {
    return this._data.vessel
  }
  set vessel(vessel) {
    this._data.vessel = vessel
  }

  get voyage() {
    return this._data.voyage
  }
  set voyage(voyage) {
    this._data.voyage = voyage
  }

  get ediCode() {
    return this._data.ediCode
  }
  set ediCode(ediCode) {
    this._data.ediCode = ediCode
  }

  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }

  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }

  async getMultiLegVoyageManagement() {
    const data = this._data
    if (typeof data.multiLegVoyageManagement !== 'object') {
      data.multiLegVoyageManagement = await multiLegVoyageManagementUrlFunc({ uuid: data.uuid }).then(res => res.data)
    }
    return data.multiLegVoyageManagement
  }
}
